import { toast } from "react-toastify";

import { GET } from "./axios.service";
import { toastStyles } from "../static/styles";
import { PdfFileProps } from "../types/common";

// Opens a file the backend saved for download (the Excel/CSV files, and a PDF from the PDF dialog's Open): in a new
// tab, or in this tab when a popup blocker stops that.
export const openDownload = (link: string) => {
  try {
    const newWindow = window.open(link, "_blank");
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed == "undefined"
    ) {
      throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
    }
  } catch (e) {
    window.location.href = link;
  }
};

// A list report needs both dates, and the first can't be after the second; says what is wrong when they aren't so.
export const checkReportRange = (
  fromDate?: string | null,
  toDate?: string | null
): boolean => {
  if (!fromDate || !toDate) {
    toast.error("કૃપા કરીને તારીખ દાખલ કરો.", {
      ...(toastStyles as any),
    });
    return false;
  }

  if (fromDate > toDate) {
    toast.error("તારીખ થી, તારીખ સુધી કરતાં મોટી ન હોઈ શકે.", {
      ...(toastStyles as any),
    });
    return false;
  }

  return true;
};

// Asks the backend to make a report PDF and returns its file for the PDF dialog (updatePdfFile); when it can't, shows
// the backend's message and returns null.
export const makeReport = async (
  path: string,
  params: object = {}
): Promise<PdfFileProps | null> => {
  try {
    const response: any = await GET(path, params);

    if (response?.data?.status === "success") {
      return response.data.data;
    }

    toast.error(
      response?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.",
      {
        ...(toastStyles as any),
      }
    );
  } catch (error: any) {
    toast.error(
      error?.data?.message || "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.",
      {
        ...(toastStyles as any),
      }
    );
  }

  return null;
};
